export const TRANSLATIONS_EN = {
  "about_me": "About Me",
  "skills": "Skills",
  "contact_me": "Contact Me",
  "my_cv": "My CV",
  "my_offer": "My Offer",
  "get_in_touch": "Get in touch",
};